import { Directive, ElementRef, HostBinding, NgZone } from '@angular/core';

@Directive({
  selector: 'mcrai-horizontal-ink-bar',
  host: {
    '[class.mcrai-ink-bar]': 'true',
    '[class.mcrai-ink-bar--horizontal]': 'true'
  }
})
export class McRAIHorizontalInkBar {
  constructor(
    private _elRef: ElementRef,
    private _ngZone: NgZone
  ) {}

  public alignToElement(element: HTMLElement): void {

    if (typeof requestAnimationFrame !== 'undefined') {
      this._ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => this._setStyles(element));
      });
    } else {
      this._setStyles(element);
    }
  }

  private _setStyles(element: HTMLElement): void {
    const inkBar: HTMLElement = this._elRef.nativeElement;

    inkBar.style.left = element ? (element.offsetLeft || 0) + 'px' : '0';
    inkBar.style.width = element ? (element.offsetWidth || 0) + 'px' : '0';
  }

}

@Directive({
  selector: 'mcrai-vertical-ink-bar',
  host: {
    '[class.mcrai-ink-bar]': 'true',
    '[class.mcrai-ink-bar--vertical]': 'true'
  }
})
export class McRAIVerticalInkBar {
  constructor(
    private _elRef: ElementRef,
    private _ngZone: NgZone
  ) {}

  public alignToElement(element: HTMLElement): void {

    if (typeof requestAnimationFrame !== 'undefined') {
      this._ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => this._setStyles(element));
      });
    } else {
      this._setStyles(element);
    }
  }

  private _setStyles(element: HTMLElement): void {
    const inkBar: HTMLElement = this._elRef.nativeElement;

    inkBar.style.top = element ? (element.offsetTop || 0) + 'px' : '0';
    inkBar.style.height = element ? (element.offsetHeight || 0) + 'px' : '0';
  }

}
